import axios from 'axios';
import keycloak from "../../keycloak";
import config from '../../config'
import {loadFromSessionStorage} from "../State/manage-state-storage-service";
import {RULES_KEY} from "../static-data/Configurations";
import {showError, showSuccess} from "../notification/ToastManager";

axios.defaults.withCredentials = true

export async function findAllRulesPermission() {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let response = {};
    try {
        await axios.get(config.BACK_URL + "permissions/roles/details", header)
            .then(res => {
                if (res.status === 200) {
                    response.status = res.data.status;
                    response.content = res.data.content;
                }
            })
        return response;
    } catch (e) {
        response = {
            status: e.response.data.status,
            content: null
        }
        return response;
    }
}

export async function findAllRules() {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let response = {};
    try {
        await axios.get(config.BACK_URL + "authorization/rules", header)
            .then(res => {
                if (res.status === 200) {
                    response.status = res.data.status;
                    response.content = res.data.content;
                }
            })
        return response;
    } catch (e) {
        response = {
            status: e.response.data.status,
            content: null
        }
        showError("Error", "An error was occured when retreiving PEMMDB features")
        return response;
    }
}

export async function findAllRolesRules() {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let response = {};
    try {
        await axios.get(config.BACK_URL + "authorization/roles-rules", header)
            .then(res => {
                if (res.status === 200) {
                    response.status = res.data.status;
                    response.content = res.data.content;
                }
            })
        return response;
    } catch (e) {
        response = {
            status: e.response.data.status,
            content: null
        }
        showError("Error", "An error was occurred when retrieving permissions")
        return response;
    }
}

export async function updateRolesRules(rolesRules) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token,
            'Content-Type': 'application/json'
        }
    }
    let response = {};
    try {
        await axios.post(config.BACK_URL + "authorization/update/roles-rules", rolesRules, header)
            .then(res => {
                if (res.status === 200) {
                    showSuccess("Success", "Permissions are updated successfully");
                    response.status = res.data.status;
                    response.content = res.data.content;
                }
            })
        return response;
    } catch (e) {
        response = {
            status: e.response.data.status,
            content: null
        }
        showError("Error", "An error was occured when updating permissions")
        return response;
    }
}
export function isAuthorized(ruleCode) {
    const rules = loadFromSessionStorage(RULES_KEY)
    return rules !== null ? rules.includes(ruleCode) : false;
}
